<div fxFlex fxLayout="column" fxLayoutGap="1rem">
  <mat-toolbar>
    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
      <span>{{ 'user.management' | translate }}</span>
      <button mat-raised-button *ngxPermissionsOnly="['ROLE_USER']" color="primary" (click)="editUser()">
        <mat-icon>add</mat-icon>
        {{ 'user.actions.create' | translate }}
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <mat-card appearance="outlined" fxFlex="grow" fxLayout="column">
    <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onChangeTab($event)">
      <mat-tab [label]="'user.enabled' | translate"></mat-tab>
      <mat-tab [label]="'user.disabled' | translate"></mat-tab>
    </mat-tab-group>
    <table mat-table [dataSource]="dataSource" class="main-content" #usersTable>
      <ng-container matColumnDef="firstName">
        <th mat-header-cell *matHeaderCellDef class="firstName">{{ 'user.firstName' | translate }}</th>
        <td mat-cell *matCellDef="let user" class="firstName">{{ user.firstName }}</td>
      </ng-container>
      <ng-container matColumnDef="lastName">
        <th mat-header-cell *matHeaderCellDef>{{ 'user.lastName' | translate }}</th>
        <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
      </ng-container>
      <ng-container matColumnDef="shortHand">
        <th mat-header-cell *matHeaderCellDef>{{ 'user.abbreviation' | translate }}</th>
        <td mat-cell *matCellDef="let user">{{ user.shortHand }}</td>
      </ng-container>
      <ng-container matColumnDef="roles">
        <th mat-header-cell *matHeaderCellDef class="roles">{{ 'user.roles.name' | translate }}</th>
        <td mat-cell *matCellDef="let user">{{ user.roles | translateRoles }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="actions">{{'core.actions' | translate}} </th>
        <td mat-cell *matCellDef="let user">
          <div fxLayout="row">
            <mat-menu #userActions>
              <button mat-menu-item (click)="editUser(user['@id'])">{{ 'user.actions.edit' | translate }}</button>
              @if (user.enabled) {
                <button mat-menu-item *ngxPermissionsOnly="['ROLE_USER']" (click)="deactivateUser(user)">{{ 'user.actions.deactivate' | translate }}</button>
              }
            </mat-menu>
            <button mat-button [matMenuTriggerFor]="userActions">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="tableColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns;"></tr>
    </table>
    @if (usersTable.dataSource.length == 0 ) {
      <app-no-result-message></app-no-result-message>
    }
  </mat-card>
</div>

@if (actionPending$ | async) {
  <div class="spinner-container">
    <mat-spinner></mat-spinner>
  </div>
}
